import { FC } from 'react';

import { BannerImageCropType } from 'utils/constants/banner';

import { Text, TextList, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

const TrlKeys = {
    vk: {
        title: 'AdCreate.AdForm.CropImage.sources.hint.vk.title',
        bullet1: 'AdCreate.AdForm.CropImage.sources.hint.vk.bullet1',
        bullet2: 'AdCreate.AdForm.CropImage.sources.hint.vk.bullet2',
        bullet3: 'AdCreate.AdForm.CropImage.sources.hint.vk.bullet3',
        bullet4: 'AdCreate.AdForm.CropImage.sources.hint.vk.bullet4',
        bullet5: 'AdCreate.AdForm.CropImage.sources.hint.vk.bullet5',
    },
    yandex: {
        title: 'AdCreate.AdForm.CropImage.sources.hint.yandex.title',
        bullet1: 'AdCreate.AdForm.CropImage.sources.hint.yandex.bullet1',
        bullet2: 'AdCreate.AdForm.CropImage.sources.hint.yandex.bullet2',
        bullet3: 'AdCreate.AdForm.CropImage.sources.hint.yandex.bullet3',
    },
};

export const TipContent: FC<{ cropType: BannerImageCropType }> = ({ cropType }) => {
    const trls = useTrls();

    return (
        <>
            <Text>{trls(TrlKeys.vk.title)}</Text>
            <VSpacing default={8} />
            <TextList>
                {Object.entries(TrlKeys.vk)
                    .filter(([key]) => key !== 'title')
                    .map(([, trl]) => (
                        <Text key={trl}>{trls(trl)}</Text>
                    ))}
            </TextList>
            {cropType === BannerImageCropType.YandexAndVK && (
                <>
                    <VSpacing default={8} />
                    <Text>{trls(TrlKeys.yandex.title)}</Text>
                    <VSpacing default={8} />
                    <TextList>
                        {Object.entries(TrlKeys.yandex)
                            .filter(([key]) => key !== 'title')
                            .map(([, trl]) => (
                                <Text key={trl}>{trls(trl)}</Text>
                            ))}
                    </TextList>
                </>
            )}
        </>
    );
};
